import { render, staticRenderFns } from "./videoChaterPartner.vue?vue&type=template&id=2c4509fe&scoped=true"
import script from "./videoChaterPartner.vue?vue&type=script&lang=js"
export * from "./videoChaterPartner.vue?vue&type=script&lang=js"
import style0 from "./videoChaterPartner.vue?vue&type=style&index=0&id=2c4509fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4509fe",
  null
  
)

export default component.exports